import React from 'react';
import PropTypes from 'prop-types';
import {useTheme, withStyles} from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import ButtonBase from '@material-ui/core/ButtonBase';
import classNames from 'classnames';

const styles = theme => ({
    root: {
        height: '100%'
        // width: '100%',

        // margin: '6px 0px'
    },
    leftSideGrid: {
        // margim:'6px 6px 6px 0px'
    },
    rigthSideGrid: {
        // margim:'6px 0px 6px 6px'
    },
    paper: {
        padding: '0px',
        margin: '0 0 0 0',
        boxShadow: 'none',
        borderRadius: 3,
        width: 'auto',
        height: '100%',
     //   backgroundColor: 'orange'
    },
  container: {
    display: 'inline-block',
    width: '100%',
    margin: 'auto',
      padding: '0px'
  },
  row: {
    //padding: '2px !important'

  },
  textcenter: {
        textAlign: 'center',
      justify: 'center'
  },
    margemEsq: {
        paddingLeft: '10px',
        paddingTop: '5px'
    }
});
function ComplexGrid(props) {
    const { theme } = useTheme();

    const { classes, mainvalue, title, description, unit, leftSideGrid, rightSideGrid  } = props;
  //  console.log('complexgrid', leftSideGrid, rightSideGrid);
    return (
        <Grid item className={classNames(classes.root,{
            'classes.leftSideGrid': leftSideGrid,
            'classes.rightSideGrid': rightSideGrid
        })}>
            <Paper className={classes.paper}>
                <Grid container  className={classes.container}>
                    <Grid item className={classes.row}>
                        <Typography gutterBottom variant="h5" style={{height: '60px'}} className={classes.margemEsq}>
                            {title}
                        </Typography>
                    </Grid>
                    <Grid item className={classNames(classes.row, classes.textcenter) }>
                        <Typography  variant="h3" color="secondary"  >
                            {mainvalue}
                        </Typography>
                    </Grid>
                    <Grid item className={classNames(classes.row, classes.textcenter) }>
                        <Typography  variant="caption" >
                            {unit}
                        </Typography>

                    </Grid>
                    <Grid item xs={6} sm container className={classes.row}>
                        <Grid item xs container direction="column" spacing={16} className={classes.margemEsq}>
                            <Grid item xs>
                                <Typography gutterBottom variant="caption">{description}</Typography>
                            </Grid>

                        </Grid>

                    </Grid>
                </Grid>
            </Paper>
        </Grid>
    );
}

ComplexGrid.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles, {withTheme: true})(ComplexGrid);
